// src/pages/Policies.js  (YENİ)
import React from "react";
import POL from "../data/policies.json";

function Block({ data }) {
  return (
    <article className="policy-card">
      <h3>{data.title}</h3>
      <p>{data.intro}</p>
      {Array.isArray(data.items) && (
        <ul className="bullet">
          {data.items.map((t, i) => <li key={i}>{t}</li>)}
        </ul>
      )}
      {data.closing && <p className="muted">{data.closing}</p>}
    </article>
  );
}

export default function Policies() {
  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">Politikalarımız</h1>
          <p className="page-subtitle">İSG, Çevre ve İnsan Kaynakları politikalarımız.</p>
        </header>

        <div className="policy-grid">
          <Block data={POL.hse} />
          <Block data={POL.environment} />
          <Block data={POL.hr} />
        </div>
      </div>
    </section>
  );
}